export default "__VITE_PUBLIC_ASSET__b3b83b2f__"